import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from '@/context/CookieConsentContext';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const { reopen } = useCookieConsent();

  const NAV = [
    { to: '/', key: 'home' },
    { to: '/about', key: 'about' },
    { to: '/services', key: 'services' },
    { to: '/work', key: 'work' },
    { to: '/insights', key: 'insights' },
    { to: '/contact', key: 'contact' },
  ];

  return (
    <footer className="bg-brand-primary text-brand-background" data-testid="site-footer">
      <div className="max-w-content mx-auto px-6 lg:px-10 py-16 md:py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <p className="font-display font-semibold uppercase text-[13px] tracking-wordmark text-brand-background">
            J Peake Consulting
          </p>
          <p className="mt-6 text-sm leading-relaxed text-brand-background/80 max-w-xs">
            {t('tagline')}
          </p>
          <p className="mt-4 text-sm text-brand-background/60">{t('location')}</p>
        </div>

        <div>
          <p className="eyebrow text-[#C9A775] mb-5">{t('footer.navigate')}</p>
          <ul className="space-y-3 text-sm">
            {NAV.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-brand-background/80 hover:text-brand-background link-underline transition-colors"
                  data-testid={`footer-link-${l.key}`}
                >
                  {t(`nav.${l.key}`)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="eyebrow text-[#C9A775] mb-5">{t('footer.contact')}</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href="mailto:contact@jpeakeconsulting.co.uk"
                className="text-brand-background/80 hover:text-brand-background link-underline"
                data-testid="footer-email-primary"
              >
                contact@jpeakeconsulting.co.uk
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/jonathandpeake/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-background/80 hover:text-brand-background link-underline"
                data-testid="footer-linkedin"
              >
                linkedin.com/in/jonathandpeake
              </a>
            </li>
            <li className="text-brand-background/60 pt-2">{t('footer.responseWindow')}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-content mx-auto px-6 lg:px-10 pt-6 pb-8 mt-0 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-xs text-brand-background/60">
          <p>© {year} J Peake Consulting. {t('footer.rights')}</p>
          <div className="flex gap-6 flex-wrap">
            <Link to="/privacy" className="hover:text-brand-background link-underline" data-testid="footer-privacy">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="hover:text-brand-background link-underline" data-testid="footer-terms">
              {t('footer.terms')}
            </Link>
            <button
              type="button"
              onClick={reopen}
              className="hover:text-brand-background link-underline text-xs text-brand-background/60 bg-transparent border-0 p-0 cursor-pointer"
              data-testid="footer-cookie-settings"
            >
              {t('footer.cookieSettings')}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
